import React from 'react';
import Banner from './Banner';
import ServiceTwo from './ServiceTwo';
import AboutTwo from './AboutTwo';
import CounterTwo from './CounterTwo';
import ProjectTwo from './ProjectTwo';
import SlidingTextOne from '../../components/Common/SlidingTextOne ';
import TeamTwo from './TeamTwo';
import ServiceThree from './ServiceThree';
import FAQTwo from './FAQTwo';
import ContactMain from '../contact/ContactMain';

// Original maroof home-2 section order, kept 1:1 — only the content of each
// section is swapped to ART-WER. ContactMain (template contact-page styling) is
// appended so the one-pager has a contact section.
// TestimonialTwo and BlogTwo are parked until real content exists: the testimonials
// are invented placeholders (fake 5★ reviews are an unfair commercial practice) and
// the blog cards link to articles that don't exist. Re-add them here once the owner
// supplies real reviews / articles.
const HomeTwoMain = () => {
	return (
		<main id="main-inhoud">
			<Banner />
			<ServiceTwo />
			<AboutTwo />
			<CounterTwo />
			<ProjectTwo />
			<SlidingTextOne />
			<TeamTwo />
			<ServiceThree />
			<FAQTwo />
			<ContactMain />
		</main>
	);
}

export default HomeTwoMain;
